import { useSelector } from "react-redux";
import "./videoInfo.cmp.scss";
import DOMPurify from "dompurify";

const CmpVideoInfo = ({ onLinkClick }) => {
	const video = useSelector(state => state.video.currVideo);
	const sanitizedDescription = video ? DOMPurify.sanitize(video["description"] || "") : "";
  const sanitizedDescriptionIa = video && video["fromIa"] ? DOMPurify.sanitize(video["descriptionIa"] || "") : "";
	const handleContainerClick = (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    const href = link.getAttribute("href");
    if (!href) return;

    // Check if link matches /video format and parse params
    const parsedData = parseVideoLink(href);

    if (parsedData.shouldIntercept) {
      e.preventDefault(); // Prevent full page refresh
      
      // Pass full href plus parsed query params up to parent
      onLinkClick?.({
        href,
        id: parsedData.id,
        timestamp: parsedData.timestamp,
      });
    }
  };
	/**
   * Evaluates if href starts with /video and extracts URL parameters
   */
  const parseVideoLink = (href) => {
    try {
      // Pass window.location.origin as base to resolve relative paths like "/video?id=..."
      const url = new URL(href, window.location.origin);

      // 1. Check path matches "/video"
      const isVideoPath = url.pathname === "/video";

      // 2. Extract query parameters
      const id = url.searchParams.get("id");
      const timestamp = url.searchParams.get("t");

      return {
        shouldIntercept: isVideoPath && id !== null,
        id,
        timestamp,
      };
    } catch {
      return { shouldIntercept: false };
    }
  };

	/**
	 * Evaluates whether a link should be intercepted.
	 * Customize this condition based on your rules.
	 */
	const evaluateLink = (href, linkElement) => {
		// Example 1: Intercept internal site paths (e.g., starts with "/" or your domain)
		const isInternal = href.startsWith("/") || href.includes(window.location.hostname);
		
		// Example 2: Intercept specific hash/anchor tags or routes (e.g., "#timestamp", "/watch?v=")
		const isTimestamp = href.includes("#t=") || href.includes("timestamp");

		// Example 3: Check custom HTML attributes preserved by DOMPurify
		const isSpecialAction = linkElement.dataset.action === "custom-nav";

		return isInternal || isTimestamp || isSpecialAction;
	};

	return video ? <>
    <div class="spacer"></div>
    <div className = "cmp-video-info">
		  <h5 className = "title">{video.title}</h5>
		  <div dangerouslySetInnerHTML = {{__html: sanitizedDescription}}
		  onClick={handleContainerClick} />
	
  </div> 
  {
    video["fromIa"] ? 
    <div className = "toc" dangerouslySetInnerHTML = {{__html: sanitizedDescriptionIa}}
		  onClick={handleContainerClick} />
     : null
  }
  </> : null
};

export default CmpVideoInfo;